export const themeColor = '#002755';

export const CONTROL_HEIGHT = 40;

export const inputLabelSx = {
    fontWeight: 500,
    mb: 0.5,
    display: 'flex',
    alignItems: 'center'
};